<template>
    <section class="relative block overflow-hidden">
        <div>
            <nuxt-img class="absolute z-10 hidden object-cover object-top w-full h-full lg:block"
                sizes="xs:330px sm:440px md:760px lg:1024px xl:1200x 2xl:1400px"  preload loading="eager" fetchpriority="high" format="webp" width="1280"
                height="720" :src="desktopImageSrc" :alt="desktopImageAlt"></nuxt-img>

            <nuxt-img class="absolute z-10 object-cover w-full h-full lg:hidden"
                sizes="xs:330px sm:440px md:760px lg:1024px xl:1200x 2xl:1400px"   preload loading="eager" fetchpriority="high" format="webp"
                :src="mobileImageSrc" :alt="mobileImageAlt" width="1024" height="1920"></nuxt-img>

            <div
                class="relative z-20 grid px-4 pt-8 mx-auto lg:px-0 lg:pl-4 lg:py-8 lg:h-auto 2xl:px-0 lg:gap-8 xl:gap-0 lg:pt-4 lg:pb-0 lg:grid-cols-12">
                <div
                    class="lg:mr-auto place-self-center col-span-12 lg:col-span-8 lg:py-0 xl:ml-[calc((100vw_-_1293px)_/_2)]">
                    <h2 class="top-0 px-3 py-2 mx-auto mb-4 text-2xl font-bold leading-7 text-center text-white lg:top-4 xl:top-10 lg:absolute lg:ml-0 md:text-left md:text-3xl font-ww-medium w-fit 2xl:top-20" style="background-color: rgba(226, 136, 49, 0.7);">
                        The Mushroom Coffee For Coffee People
                    </h2>
                    <h1
                        class="max-w-4xl mb-4 font-extrabold leading-none tracking-tight text-center text-black h1 lg:text-left">
                        <span v-html="headerText"></span>
                    </h1>
                    <div class="max-w-2xl mx-auto mb-6 text-center text-black lg:mb-8 h3 lg:text-left lg:ml-0">
                        <span v-html="subheaderText"></span>
                    </div>
                    <div class="text-center lg:text-left">
                        <button @click="scrollTo(scrollTarget)" class="text-white bnt-basic xs-max:w-full"  :style="{ background: primaryColor }">
                            <span v-html="buttonText2"></span>
                        </button>
                    </div>
                </div>

                <div class="col-span-12 mt-2 -mr-4 lg:mr-0 lg:col-span-4 lg:mt-0">
                    <nuxt-img class="object-contain" sizes="xs:250px sm:300px md:350px lg:350px xl:353x 2xl:472px"
                        width="1617" height="1920"  preload loading="eager" fetchpriority="high" format="webp" :src="imageSrc" :alt="imageAlt"></nuxt-img>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    desktopImageSrc: {
        type: String,
        default: "/assets/images/bg-image-112.png"
    },
    desktopImageAlt: {
        type: String,
        default: "MitoCreamer Longevity deck"
    },
    mobileImageSrc: {
        type: String,
        default: "/assets/images/mushroom-mobile-bg.png"
    },
    mobileImageAlt: {
        type: String,
        default: "MitoCreamer Longevity deck"
    },
    scrollTarget: {
        type: String,
        default: "the-products"
    },
    headerText: {
        type: String,
        default: "Revolutionize Your Mornings with Organic Cognition Mushroom Coffee"
    },
    subheaderText: {
        type: String,
        default: "Embrace the natural power of a coffee that doesn't taste like mushrooms (and is easy on your stomach!)"
    },
    buttonText2: {
        type: String,
        default: "Try it now!"
    },
    imageSrc: {
        type: String,
        default: "/assets/images/image444.png"
    },
    imageAlt: {
        type: String,
        default: "MitoCreamer Longevity deck"
    },
    primaryColor: {
        type: String,
        default: "#e28831" // Това е примерна стойност за lifeboost-orange-middle
    }
});

defineBuilderComponent({
    friendlyName: "Hero-3",
    inputs: [
        {
            name: "desktopImageSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
            defaultValue: "/assets/images/bg-image-112.png"
        },
        {
            name: "desktopImageAlt",
            type: "text",
            defaultValue: "MitoCreamer Longevity deck"
        },
        {
            name: "mobileImageSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
            defaultValue: "/assets/images/mushroom-mobile-bg.png"
        },
        {
            name: "mobileImageAlt",
            type: "text",
            defaultValue: "MitoCreamer Longevity deck"
        },
        {
            name: "scrollTarget",
            type: "text",
            defaultValue: "the-products"
        },
        {
            name: "headerText",
            type: "richText",
            defaultValue: "Revolutionize Your Mornings with Organic Cognition Mushroom Coffee"
        },
        {
            name: "subheaderText",
            type: "richText",
            defaultValue: "Embrace the natural power of a coffee that doesn't taste like mushrooms (and is easy on your stomach!)"
        },
        {
            name: "buttonText2",
            type: "text",
            defaultValue: "Try it now!"
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
            defaultValue: "/assets/images/image444.png"
        },
        {
            name: "imageAlt",
            type: "text",
            defaultValue: "MitoCreamer Longevity deck"
        },
        {
            name: "primaryColor",
            type: "color",
            defaultValue: "#e28831"
        }
    ]
});
</script>